import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';

import { ExcellenceAppsRoutes } from 'components/Dashboards/ExcellenceApps/routes';
import { PlanningRoutes } from 'components/Dashboards/Planning/routes';
import { PortfolioRoutes } from 'components/Dashboards/Portfolio/routes';
import ProjectRoutes from 'components/Dashboards/Project/ProjectWrapper/projectRoutes';
import ReportingRoutes from 'components/Dashboards/Reporting/reportingRoutes';

const Dashboards = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/${AppRoutes.RISK}`} component={ExcellenceAppsRoutes} />
            <Route path={`${path}/${AppRoutes.PLANNING}`} component={PlanningRoutes} />
            <Route path={`${path}/${AppRoutes.EXECUTION}`} component={ProjectRoutes} />
            <Route path={`${path}/${AppRoutes.PORTFOLIO}`} component={PortfolioRoutes} />
            <Route path={`${path}/${AppRoutes.REPORTING}`} component={ReportingRoutes} />
            <Route path={'*'} component={PageNotFound} />
        </Switch>
    );
};

export default Dashboards;
